import React from "react";
import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import LoginForm from "../../components/auth/LoginForm";
import { Link } from "react-router-dom";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

const LogInScreen = () => {
  const { Auth }: DictionaryType = useGetDictionary();
  localStorage.setItem("theme", "light");
  return (
    <AuthLayout>
      <div className="text-center mt-4 flex flex-col gap-8">
        <div className="flex flex-col gap-5">
          <PageTitle title={Auth?.login_page?.login_title} />

          <p className="text-lg font-normal leading-[22.68px] text-[#1E1850] mt-2">
            {Auth?.login_page?.login_subtitle}
            <span className="text-red-500">
              <Link to="/auth/register">
                {" "}
                {Auth?.login_page?.create_one_now}
              </Link>
            </span>
          </p>
        </div>

        <LoginForm />
      </div>
    </AuthLayout>
  );
};

export default LogInScreen;
